<template>
    <div class="container">
        <div class="header">
            <van-tabs animated>
                <template #nav-left>
                    <van-icon @click="onClickLeft" name="arrow-left" /></template>
                <van-tab title="VIP等级任务说明">
                    <div class="table-box" v-html="levelContent"></div>
                </van-tab>
                <van-tab title="处罚说明">
                    <div class="table-box" v-html="punishContent"></div>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>
<script>
    import api from '../Api'
    export default {
        mixins: [api],
        data() {
            return {
                levelContent: "",
                punishContent: "",
            };
        },
        created() {},
        mounted() {
            this.pointInfo();
        },
        methods: {
            pointInfo() {
                this.$Ajax("/vip-task/point-level-info", {
                    type: "level"
                }).then((rs) => {
                    this.levelContent = rs.data.content;
                });

                this.$Ajax("/vip-task/point-level-info", {
                    type: "punish"
                }).then(
                    (rs) => {
                        this.punishContent = rs.data.content;
                    }
                );
            },
        },
    };
</script>
<style lang="less" scoped>
    .header {
        :deep(.van-tab) {
            flex: none;
        }

        :deep(.van-tabs__line) {
            margin-bottom: 0.35rem;
        }

        :deep(.van-tabs--line) {
            .van-tabs__wrap {
                height: 2.5rem;
                position: sticky;
                top: 0;
                z-index: 10;
            }
        }

        :deep(.van-icon-arrow-left) {
            position: absolute;
            top: 0.75rem;
            align-items: center;
            display: flex;
            justify-content: center;
            left: 0.8rem;
            color: #111111;
            font-size: 1rem;
            cursor: pointer;
        }

        :deep(.van-tabs__nav) {
            padding-left: 3.5rem;
            gap: 2.55rem;
        }

        :deep(.van-tab--active) {
            font-size: 0.8rem;
            color: #000000;
            font-weight: bold;
        }

        .van-tab__text {
            color: #656565;
            font-size: 0.7rem;
        }
    }

    .table-box {
        margin: 0.9rem 1.35rem 0;
    }
</style>